(function($, window, document) {
    "use strict";
    $(function() {
        //##Variables
        var $body = $('body'),
            $window = $(window),
            $html = $('html'),
            $hamburger = $('.hamburger'),
            $doc = $(document),
            $mainNav = $('.mainNav'),
            defaultEasing = [0.4, 0.0, 0.2, 1];
        //End Variables

        $hamburger.click(function() {
            $body.toggleClass('menuopened');
            $('.mainNav').toggleClass('menutoggled');
            $(this).toggleClass('toggled');
            $mainNav.slideToggle('fast');
            setTimeout(function() {
                jQuery('body').addClass('menu-opened');
            }, 800)
        });


        // $(window).load(function() {
        // });
        setTimeout(function() {
            $('body').addClass('loaded'); 
        }, 600)

        // animations

        /* $(".sectionTitleWrap").addClass("animated-title");
         $(window).on('scroll', function() {
             $(".sectionTitleWrap").each(function() {
                 if (isScrolledIntoView($(this))) {
                     $(this).find(".sectionTitle").addClass("animated-title");
                 }
             });
         });*/


        // $(".service-row").addClass("service-row-animated");
        /*   $(window).on('scroll', function() {
               $(".service-row").each(function() {
                   if (isScrolledIntoView($(this))) {
                       $(this).find(".article-list").addClass("article-list-animated");
                   }
               });
           });*/


        function isScrolledIntoView(elem) {
            var docViewTop = jQuery(window).scrollTop();
            var docViewBottom = docViewTop + jQuery(window).height();

            var elemTop = jQuery(elem).offset().top;
            var elemBottom = elemTop + jQuery(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        //Waypoints
        if (document.getElementById('clientItems')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('clientItems'),
                handler: function(direction) {
                    if(document.getElementById('client-title')) {
                    document.getElementById('client-title').classList.add('animated-title');
                    }
                    document.getElementById('clientItems').classList.add('is-anim');
                    this.destroy();
                },
                offset: '120%', 
                triggerOnce: true
            });
        }
        if (document.getElementById('clientItemsSecond')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('clientItemsSecond'),
                handler: function(direction) {
                    document.getElementById('client-title-2').classList.add('animated-title');
                    document.getElementById('clientItemsSecond').classList.add('is-anim');
                    this.destroy();
                },
                offset: '65%',
                triggerOnce: true
            });
        }
        if (document.getElementById('service-row')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('service-row'),
                handler: function(direction) {
                    var list = document.querySelectorAll('.service-row .article-list');

                    for (var i = 0; i < list.length; ++i) {
                        list[i].classList.add('article-list-animated');
                    }

                    this.destroy();
                },
                offset: '90%',
                triggerOnce: true
            });
        }
        if (document.getElementById('ourWork')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('ourWork'),
                handler: function(direction) {
                    document.getElementById('ourWork').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('teamSection')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('teamSection'),
                handler: function(direction) {
                    document.getElementById('teamSection').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('forUs')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('forUs'),
                handler: function(direction) {
                    document.getElementById('forUs').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('hallakateSection')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('hallakateSection'),
                handler: function(direction) {
                    document.getElementById('hallakateSection').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('footer')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('footer'),
                handler: function(direction) {
                    document.getElementById('footer').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('our-service-section')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('our-service-section'),
                handler: function(direction) {
                    document.getElementById('our-service-section').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('timeline-section')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('timeline-section'),
                handler: function(direction) {
                    document.getElementById('timeline-section').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('partnerSection')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('partnerSection'),
                handler: function(direction) {
                    document.getElementById('partnerSection').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }

        if (document.getElementById('workProcess')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('workProcess'),
                handler: function(direction) {
                    document.getElementById('workProcess').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
        if (document.getElementById('workProcess')) {
            var waypointServices = new Waypoint({
                element: document.getElementById('workProcess'),
                handler: function(direction) {
                    document.getElementById('workProcess').classList.add('is-anim');
                    this.destroy();
                },
                offset: '60%',
                triggerOnce: true
            });
        }
     
        $('.owl-carousel').owlCarousel({ 
            loop: true,
            nav: true,
            lazyLoad: true,
            dots: true,
            items: 3,
            responsive: {
                0: {
                    items: 1 
                },
                600: {
                    items: 1
                },
                768: {
                    items: 2 
                },
                1000: {
                    items: 3
                }
            }
        });
 
        if ($(window).width() > 767) {
            $(window).scroll(function() {
                var scroll = $(window).scrollTop(); 
                if (scroll >= 207) {
                    $(".fixed-profile-banner").addClass("profileBanner-fixed");
                } 

                if (scroll < 207) {
                    $(".fixed-profile-banner").removeClass("profileBanner-fixed");
                }

                scrollCircleBorder(scroll)
            });


            function scrollCircleBorder(scroll) {
                var profileBoxHolder = document.getElementById('profile-box-holder');

                if (!profileBoxHolder) {
                    return
                }

                var offset = elementOffset(profileBoxHolder);

                var from = offset.top,
                    to = offset.top + offset.height;

                if (scroll > from - 100 && scroll < to + 100) {
                    var diff = to - from,
                        current = scroll - from,
                        percentage = current / diff * 100,

                        min = 510,
                        max = 1220,
                        diff = max - min;

                    var fill = diff * percentage / 100;

                    var newValue = min + fill;

                    document.getElementById('circle-border').style.strokeDasharray = newValue + " 1709.0264035528476"
                }
            }

            function elementOffset(el) {
                var rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return { top: rect.top + scrollTop, left: rect.left + scrollLeft, height: rect.height }
            }

            $('.sticky_wrap_1').scrollFix({
                side: 'top',
                topPosition: 20,

            });
            $('.sticky_profile-2').scrollFix({
                // side: 'top',
                side: 'top',
                topPosition: 20,
                bottomPosition: -1000,

            });
            $('.sticky_profile-3').scrollFix({
                side: 'top',
                topPosition: 20,
                bottomPosition: 20,

            });
            $('.name-position').scrollFix({
                side: 'top',
                topPosition: 0,
            });
            $(window).load(function() {
                setTimeout(function() {
                    var app = document.getElementById('title');
                    if (app) {
                        var typewriter = new Typewriter(app, {
                            loop: false
                        });
                        var typewriterString = typewriter.typeString(hallakate_banner_words.first_word);
                        for (var i = 0; i < hallakate_banner_words.words.length; i++) {
                            typewriterString.typeString('<strong>' + hallakate_banner_words.words[i].banner_words + '</strong>')
                                .pauseFor(2000)
                                .deleteChars(hallakate_banner_words.words[i].banner_words.length)
                        }
                        typewriterString.start();
                    }
                }, 1200)
                /* Act on the event */
            });

        } 

        $(".workflow").addClass("animated-workflow");
        $(window).on('scroll', function() {
            $(".animated-workflow").each(function() {
                if (isScrolledIntoView($(this))) {
                    $(this).find(".workProcess").addClass("visited");
                }
            });
            /*if ($body.hasClass('our_team-template-default')) {
                if (isScrolledIntoView($(".profileRightSide-1"))) {
                    $("#image-circle").attr('fill', 'url(#photo-1)')
                } else if (isScrolledIntoView($(".profileRightSide-2"))) {
                    $("#image-circle").attr('fill', 'url(#photo-2)')
                } else if (isScrolledIntoView($(".profileRightSide-3"))) {
                    $("#image-circle").attr('fill', 'url(#photo-3)')
                }
            }*/
            if ($body.hasClass('our_team-template-default')) {
                var webpage = $(".profileWrap");
                var webpage_height = webpage.height();
                //alert(webpage_height);
                var trigger_height25 = webpage_height * 0.25;
                var trigger_height50 = webpage_height * 0.50;
                var trigger_height75 = webpage_height * 0.90;

                if ($(window).scrollTop() > (webpage_height - trigger_height75)) {
                    $("#image-circle").attr('fill', 'url(#photo-1)') 

                } 
                if ($(window).scrollTop() > (webpage_height - trigger_height50)) {
                    $("#image-circle").attr('fill', 'url(#photo-2)')

                } 
                if ($(window).scrollTop() > (webpage_height - trigger_height25)) {
                    $("#image-circle").attr('fill', 'url(#photo-3)')

                } 
            }
        });


        //single profile script

        function isScrolledIntoView(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            // console.log(elem.selector);
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            if (elem.selector == '.profileRightSide-1') { 
                elemTop += 450;
            }
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }


        var divHeight = $('.profileRightSide-1').outerHeight();
        $('.view-height-1').css('min-height', divHeight + 'px');

        var divHeight = $('.profileRightSide-2').outerHeight();
        $('.view-height-2').css('min-height', divHeight + 'px');

        var divHeight = $('.profileRightSide-3').outerHeight();
        $('.view-height-3').css('min-height', divHeight + 'px');

        $(document).ready(function() {
            $(".tnp-email").attr("placeholder", "example@e-mail.com");
        });




        console.log("%c Developed by: Kutia Digital Agency http://kutia.net", "padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d");
    });
}(window.jQuery, window, document));